(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/lyckoplatsen/components/shared-charity/assets/react/components/more-charities-text.js') >= 0) return;  svs.modules.push('/modules/lyckoplatsen/components/shared-charity/assets/react/components/more-charities-text.js');

'use strict';

const MoreCharitiesText = () => React.createElement(React.Fragment, null, React.createElement("p", {
  className: "h2 margin-bottom-2 margin-top-2 align-left"
}, "Fler organisationer tillkommer"), React.createElement("p", {
  className: "margin-bottom-1-half align-left"
}, "F\xF6r att alla ska kunna hitta en organisation som ligger dem extra varmt om hj\xE4rtat kommer vi l\xF6pande att uppdatera listan med organisationer du kan v\xE4lja att st\xF6tta."));
setGlobal('svs.lyckoplatsen.components.shared_charity.react.components', {
  MoreCharitiesText
});

 })(window);